<template>
    <div><editartical-component/></div>
</template>

<script>
import editarticalComponent from '../../components/bolg/editartical.component.vue'
export default {
  components: { editarticalComponent },
    
}
</script>